import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function PaymentServicesEMILicenseMalta() {

    return (
        <main className='main'>
            <IntroSection
                title="Payment Services & EMI License – Malta (MFSA)"
                subtitle="Operate as a Licensed PSP or EMI in the European Union"
                description="Malta is a leading jurisdiction for Payment Institutions (PSPs) and Electronic Money Institutions (EMIs), licensed by the Malta Financial Services Authority (MFSA). With an MFSA license, you gain full passporting rights across the European Economic Area (EEA) under EU directives, allowing you to serve millions of clients with regulated payment solutions."
                badges={[
                    "Payment Processing",
                    "Merchant Acquiring",
                    "E-Wallets",
                    "IBAN Issuing",
                    "Prepaid Cards"
                ]}
                buttonText="Request a Malta EMI Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/payment-services-EMI-license-malta-hero.png")}
                imageAlt="Malta Payment Services & EMI"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Malta for Payments & EMI?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "EU Passporting",
                                                text: "Serve clients across the EEA with one license."
                                            },
                                            {
                                                title: "PSD2 & EMD Compliance",
                                                text: "Regulated under EU directives."
                                            },
                                            {
                                                title: "Banking & Card Access",
                                                text: "Easier Visa, Mastercard, SEPA, and SWIFT integration."
                                            },
                                            {
                                                title: "FinTech Hub",
                                                text: "Strong support for digital banking, PSPs, and EMI startups."
                                            },
                                            {
                                                title: "Investor & Client Trust",
                                                text: "Tier-1 EU regulator credibility."
                                            },
                                            {
                                                title: "Scalable",
                                                text: "Launch with PSP services and expand to EMI later."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Payment Licenses in Malta"
                        blocks={[
                            {
                                title: "Payment Institution License (PI)",
                                items: [
                                    { text: "Offer payment services: remittances, merchant acquiring, money transfer." },
                                    { text: "Issue IBANs and facilitate payment processing." },
                                    { text: "Capital Requirement: €125,000 minimum." }
                                ]
                            },
                            {
                                title: "Electronic Money Institution License (EMI)",
                                items: [
                                    { text: "Issue electronic money (e-wallets, prepaid cards)." },
                                    { text: "Provide IBANs and virtual/physical debit cards." },
                                    { text: "Act as a PSP with extended rights." },
                                    { text: "Capital Requirement: €350,000 minimum." }
                                ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Services Covered by a Malta EMI License"
                        item={
                            [
                                {
                                    title: "Multi-Currency Wallets",
                                    text: "Issue and manage e-wallets in multiple currencies."
                                },
                                {
                                    title: "IBAN Accounts",
                                    text: "Provide clients with IBANs for SEPA and international transfers."
                                },
                                {
                                    title: "Card Programs",
                                    text: "Prepaid & debit card issuance (Visa/Mastercard)."
                                },
                                {
                                    title: "Payment Processing",
                                    text: "Merchant acquiring and transaction processing."
                                },
                                {
                                    title: "Remittance & Transfers",
                                    text: "Handle money transfer services efficiently."
                                },
                                {
                                    title: "Crypto-to-Fiat Gateways",
                                    text: "Integrate under compliance rules where allowed."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Malta EMI License'
                        services={
                            [
                                {
                                    title: "EU-Wide Market Access",
                                    text: "Serve 30+ EEA countries."
                                },
                                {
                                    title: "Full Banking Integration",
                                    text: "SEPA, SWIFT, and card scheme connectivity."
                                },
                                {
                                    title: "Tier-1 Credibility",
                                    text: "Respected by investors, clients, and regulators."
                                },
                                {
                                    title: "Investor Confidence",
                                    text: "Licensed EMIs attract venture capital & institutional partnerships."
                                },
                                {
                                    title: "Growth Potential",
                                    text: "EMI license serves as a stepping stone to full digital banking."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Consultation & Planning",
                                    text: "Select PI or EMI model."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Establish a Malta entity."
                                },
                                {
                                    title: "Application Submission",
                                    text: "Prepare AML/KYC manuals, governance documents, business plan, and capital proof."
                                },
                                {
                                    title: "MFSA Review",
                                    text: "Regulator conducts due diligence on shareholders and management."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Typically completed in 6–9 months."
                                },
                                {
                                    title: "Operational Setup",
                                    text: "Card issuing, IBAN integration, and PSP onboarding."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "6–9 months",
                            },
                            {
                                name: "Setup Costs",
                                description: "From €100,000+ (legal, compliance, audit, incorporation)",
                            },
                            {
                                name: "Capital Requirement",
                                description: "€125,000 (PI) / €350,000 (EMI)",
                            },
                            {
                                name: "Annual Costs",
                                description: "Audits, MFSA fees, compliance reporting",
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Specialists in PSD2 & EMI licensing in the EU" },
                                { text: "End-to-end services: company setup, license application, compliance manuals" },
                                { text: "Introductions to banking partners, card issuers, and processors" },
                                { text: "Support for IBAN issuing, e-wallet platforms, and crypto integration" },
                                { text: "Comparison: Malta vs offshore EMI (Anjouan, Mwali, Western Sahara)" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to operate an EU payment or e-money institution?"
                        description="Malta offers Tier-1 EMI and PSP licenses with full EU passporting rights and access to Visa, Mastercard, SEPA, and SWIFT networks."
                        buttonText="Book a Malta EMI License Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is the difference between PI and EMI?",
        content: [
            { type: "answer", text: "PI = payment services only; EMI = payment + e-money issuance (wallets, cards)." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "6–9 months on average." },
        ],
    },
    {
        question: "What capital is required?",
        content: [
            { type: "answer", text: "€125k for PI, €350k for EMI." },
        ],
    },
    {
        question: "Can EMI issue cards and IBANs?",
        content: [
            { type: "answer", text: "Yes — EMIs are authorized to offer card programs and IBAN accounts." },
        ],
    },
    {
        question: "Does Malta EMI support crypto payments?",
        content: [
            { type: "answer", text: "Yes — regulated firms can offer crypto-to-fiat gateways under compliance rules." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We licensed our EMI in Malta with Offshore Advisory. The process was strict, but now we have EU-wide recognition and card issuing rights.",
        author: "Richard M.",
        role: "FinTech CEO"
    },
    {
        quote: "Our PSP business expanded into an EMI in Malta. Offshore Advisory managed the compliance and Visa/Mastercard onboarding.",
        author: "Sofia K.",
        role: "Payment Services Director"
    }
];
